import React, { useState, useEffect, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import "../ShipmentSelectScanType.css";
import { UserContext } from "../../common/UserContext";
import config from "../../../envconfig";
import CustomDropdown from "../../common/CustomDropdown";
import Icon4 from "../../../assest/images/Icon4.png";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import Icon3 from "../../../assest/images/Icon3.png";
// import Image from '../common/image';
function ShipOutScanPendingList() {
  const {
    UM_GroupId,
    UM_CompanyGrpID,
    selectedScpId,
    UM_CompanyID,
    UM_UserId,
    UM_UserCode,
    UM_DefaultSCPId,
  } = useContext(UserContext);
  const [userData, setUserdata] = useState([]);
  const [returnData, setReturnData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(9); // You can adjust the number of items per page here
  const navigate = useNavigate();
  const [navigateTo, setNavigateTo] = useState("");

  const logAction = async (action, isError = false) => {
    try {
      const response = await fetch(`${config.API_URL}/api/log`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          module: "Shipment Outward Pending List :",
          action,
          userCode: UM_UserCode,
          isError,
        }),
      });
      if (!response.ok) {
        throw new Error("Failed to log action");
      }
    } catch (error) {
      console.error("Error logging action:", error);
    }
  };

  const handleRowClick = (shipment) => {
    if (shipment.SHPH_Status === 12 || shipment.SHPR_Status === 12) {
      return; // Do nothing and exit the function
    }
    if (shipment.SHPH_ByProductVendorScanMode === 1) {
      setNavigateTo(`/ShipOutScanByVendor/${shipment.SHPH_ShipmentID}`);
      logAction(
        `Navigated To '/ShipOutScanByVendor' Shipment Outward canning By Vendor with Shipment ID ${shipment.SHPH_ShipmentID} and Shipment Code ${shipment.SHPH_ShipmentCode}`,
        true
      );
    } else if (shipment.SHPH_ByProductVendorScanMode === 2) {
      setNavigateTo(`/ShipOutScanByProduct/${shipment.SHPH_ShipmentID}`);
      logAction(
        `Navigated To '/ShipOutScanByProduct' Shipment Outward canning By Product with Shipment ID ${shipment.SHPH_ShipmentID} and Shipment Code ${shipment.SHPH_ShipmentCode}`
      );
    } else if (
      shipment.SHPR_ShipmentType === "Return" ||
      shipment.SHPR_ShipmentReturnCode.startsWith("RET_")
    ) {
      setNavigateTo(`/ShipOutReturnScan/${shipment.SHPR_ShipmentID}`);
      logAction(
        `Navigated To '/ShipOutScanByProduct' Shipment Outward canning By Product with Shipment ID ${shipment.SHPR_ShipmentID} and Shipment Code ${shipment.SHPR_ShipmentReturnCode}`
      );
    }
  };
  //========
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [selectedShipment, setSelectedShipment] = useState(null);
  const [SuspendShipments, setSuspendShipments] = useState([]);
  const [Message, setMessage] = useState([]);

  const handleSuspendClick = (shipment) => {
    setSelectedShipment(shipment);
    setIsPopupVisible(true); // Show popup
    if (shipment.SHPH_ShipmentType === "New Order") {
      setMessage(
        `Are you sure you want to suspend Shipment :  ${shipment.SHPH_ShipmentCode} ?`
      );
      logAction(
        `Are you sure you want to suspend Shipment :  ${shipment.SHPH_ShipmentCode} ?`
      );
    } else if (shipment.SHPR_ShipmentType === "Return") {
      setMessage(
        `Are you sure you want to suspend Shipment :  ${shipment.SHPR_ShipmentReturnCode} ?`
      );
      logAction(
        `Are you sure you want to suspend Shipment :  ${shipment.SHPR_ShipmentReturnCode} ?`
      );
    }
  };
  const [remark, setRemark] = useState('');
  const [error, setError] = useState('');

  const handleRemarkChange = (e) => {
    const value = e.target.value;
    setRemark(value);
    if (error && value.trim() !== '') {
      setError(''); // Clear the error once the user starts typing
    }
  };


  const confirmSuspend = () => {
    if (!remark.trim()) {
      setError('*');
      return;
    }

    const shipment = selectedShipment;
    const SHPH_ShipmentID = shipment.SHPH_ShipmentID;
    const SHPR_ShipmentID = shipment.SHPR_ShipmentID;

    const payload = { SHPH_Comment: remark }; // Send the remark value
    const payload01 = { SHPR_Comment: remark }; // Send the remark value

    if (shipment.SHPH_ShipmentType === "New Order") {
      axios
        .put(
          `${config.API_URL}/Suspend_Shipment/${SHPH_ShipmentID}/${selectedScpId}`,
          payload // Pass the payload here
        )
        .then((response) => {
          toast.success(`Shipment : ${shipment.SHPH_ShipmentCode} suspended successfully.`);
          logAction(
            `Shipment ${shipment.SHPH_ShipmentCode} Suspend Sucessfully by User: ${UM_UserCode} SCP ID: ${selectedScpId}`
          );
          setSuspendShipments((prev) => [...prev, SHPH_ShipmentID]);
        })
        .catch((error) => {
          if (error.response && error.response.status === 404) {
            toast.error("Shipment not found");
            logAction(`Shipment : ${shipment.SHPH_ShipmentCode} Not Found`);
          } else {
            toast.error("Error suspending shipment");
          }
        });
    } else if (shipment.SHPR_ShipmentType === "Return") {
      axios
        .put(
          `${config.API_URL}/Suspend_Shipment_Return/${SHPR_ShipmentID}/${selectedScpId}`,
          payload01 // Pass the payload here
        )
        .then((response) => {
          toast.success(`Shipment : ${shipment.SHPR_ShipmentReturnCode} suspended successfully.`);
          logAction(
            `Shipment : ${shipment.SHPR_ShipmentReturnCode} Suspend Sucessfully by User: ${UM_UserCode} SCP ID: ${selectedScpId}`
          );
          setSuspendShipments((prev) => [...prev, SHPR_ShipmentID]);
        })
        .catch((error) => {
          if (error.response && error.response.status === 404) {
            toast.error("Shipment not found");
            logAction(`Shipment ${shipment.SHPR_ShipmentReturnCode} Not Found`);
          } else {
            toast.error("Error suspending shipment");
          }
        });
    } else {
      console.log("Invalid data");
    }
    setIsPopupVisible(false); // Close popup after confirming
  };

  const closePopup = () => {
    setIsPopupVisible(false);
    setRemark('');            // clear remark textarea
    setError('');
  };

  useEffect(() => {
    if (navigateTo) {
      navigate(navigateTo);
    }
  }, [navigate, navigateTo]);

  // ========================================================================================================
  //                                           Filteration
  // ========================================================================================================
  const [firstFilter, setFirstFilter] = useState(""); // First filter selection
  const [firstFilterSearch, setFirstFilterSearch] = useState(""); // First filter search input
  const [secondFilter, setSecondFilter] = useState(""); // Second filter selection
  const [secondFilterSearch, setSecondFilterSearch] = useState(""); // Second filter search input
  const [statusFilter, setStatusFilter] = useState(""); // Status filter selection

  const [firstFilterOptions, setFirstFilterOptions] = useState([
    { value: "SHPH_ShipmentType", label: "Shipment Type", disabled: false },
    { value: "SHPH_ShipmentCode", label: "Shipment Code", disabled: false },
    { value: "LGCM_Name", label: "Logistic Party", disabled: false },
    { value: "LGCVM_VehicleNumber", label: "Vehicle Number", disabled: false },
    { value: "RUTL_Name", label: "Route Name", disabled: false },
  ]);
  const [secondFilterOptions, setSecondFilterOptions] = useState([
    { value: "SHPH_ShipmentType", label: "Shipment Type", disabled: false },
    { value: "SHPH_ShipmentCode", label: "Shipment Code", disabled: false },
    { value: "LGCM_Name", label: "Logistic Party", disabled: false },
    { value: "LGCVM_VehicleNumber", label: "Vehicle Number", disabled: false },
    { value: "RUTL_Name", label: "Route Name", disabled: false },
  ]);

  const handleFirstFilterChange = (event) => {
    const value = event.target.value;
    setFirstFilter(value);
    setFirstFilterSearch("");
    const updatedSecondOptions = secondFilterOptions.map((option) => ({
      ...option,
      disabled: option.value === value,
    }));
    setSecondFilterOptions(updatedSecondOptions);
  };
  const handleSecondFilterChange = (event) => {
    const value = event.target.value;
    setSecondFilter(value);
    setSecondFilterSearch("");
    const updatedFirstOptions = firstFilterOptions.map((option) => ({
      ...option,
      disabled: option.value === value,
    }));
    setFirstFilterOptions(updatedFirstOptions);
  };
  useEffect(() => {
    // Whenever any of the filters change, reset to the first page
    setCurrentPage(1);
  }, [firstFilterSearch, secondFilterSearch, statusFilter]);

  const getStatusLabel = (status) => {
    switch (status) {
      case 1:
        return "Active";
      case 2:
        return "Inactive";
      case 3:
        return "Suspend";
      default:
        return "";
    }
  };

  const safeString = (value) => (value && typeof value === 'string') ? value : '';

  const filteredCombinedData = [...userData, ...returnData].filter((item) => {
    const firstFilterValue = item[firstFilter];
    const secondFilterValue = item[secondFilter];

    const firstFilterValStr = (firstFilter === "LCM_Status") ? getStatusLabel(firstFilterValue) : safeString(firstFilterValue);
    const secondFilterValStr = safeString(secondFilterValue);

    const containsActive = /act(ive)?/i.test(firstFilterSearch);
    const containsInactive = /inact(ive)?/i.test(firstFilterSearch);

    const matchesFirstFilter =
      !firstFilter ||
      !firstFilterSearch ||
      (firstFilter === "LCM_Status" &&
        ((containsActive && firstFilterValue === 1) ||
          (containsInactive && firstFilterValue === 2))) ||
      (firstFilter !== "LCM_Status" &&
        firstFilterValStr.toLowerCase().includes(firstFilterSearch.toLowerCase()));

    const containsActive2 = /act(ive)?/i.test(secondFilterSearch);
    const containsInactive2 = /inact(ive)?/i.test(secondFilterSearch);

    const matchesSecondFilter =
      !secondFilter ||
      !secondFilterSearch ||
      (secondFilter === "LCM_Status" &&
        ((containsActive2 && secondFilterValue === 1) ||
          (containsInactive2 && secondFilterValue === 2))) ||
      (secondFilter !== "LCM_Status" &&
        secondFilterValStr.toLowerCase().includes(secondFilterSearch.toLowerCase()));

    const statusVal = getStatusLabel(item.LCM_Status);
    const matchesStatusFilter = !statusFilter || statusVal === statusFilter;

    return matchesFirstFilter && matchesSecondFilter && matchesStatusFilter;
  });
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentPosts = filteredCombinedData.slice(
    indexOfFirstItem,
    indexOfLastItem
  );

  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const indexOfLastPost = currentPage * itemsPerPage;
  const indexOfFirstPost = indexOfLastPost - itemsPerPage;

  const handleStatusFilterChange = (event) => {
    const value = event.target.value;
    setStatusFilter(value);
  };

  // ========================================================================================================
  //                                           Filteration
  // ========================================================================================================

  useEffect(() => {
    const fetchShipmentData = async () => {
      try {
        const reqData1 = await fetch(
          `${config.API_URL}/Shipment_Pending_Scanning/${UM_CompanyGrpID}/${UM_CompanyID}/${selectedScpId}`,
          {
            method: "GET",
          }
        );
        let resData1 = [];
        if (reqData1.ok) {
          const resJson1 = await reqData1.json();
          resData1 = resJson1.shipment;
          console.log("Data from first API:", resData1); // Debugging
        } else {
          console.error("Error fetching the shipment list from the first API");
        }

        const reqData2 = await fetch(
          `${config.API_URL}/Shipment_ReturnPending_Scanning/${UM_CompanyGrpID}/${UM_CompanyID}/${selectedScpId}`,
          {
            method: "GET",
          }
        );
        let resData2 = [];
        if (reqData2.ok) {
          const resJson2 = await reqData2.json();
          resData2 = resJson2.Shipmentreturn;
          console.log("Data from second API:", resData2); // Debugging
        } else {
          console.error(
            "Error fetching the shipment return list from the second API"
          );
        }
        setUserdata(resData1);
        setReturnData(resData2);
      } catch (error) {
        console.log("Failed to fetch data:", error);
      }
    };
    fetchShipmentData();
  }, [UM_CompanyGrpID, UM_CompanyID, selectedScpId]);

  return (
    <>
      <ToastContainer
        style={{
          marginTop: "73px",
          fontSize: "14px",
          width: "40%",
        }}
      />
      <div className="main_container">
        <h4 className="formHeading">Pending Outward</h4>
        <div className="row">
          <div className="mb-3">
            <div className="filter-container">
              <div className="select-container_list">
                <CustomDropdown
                  options={firstFilterOptions}
                  value={firstFilter}
                  onChange={handleFirstFilterChange}
                  name="firstFilter"
                  placeholder="--Select--"
                  idKey="value"
                  displayKey="label"
                />
              </div>
              <input
                type="text"
                className="search-input"
                value={firstFilterSearch}
                onChange={(e) => setFirstFilterSearch(e.target.value)}
                placeholder={`Search`}
              />
              <div className="select-container_list">
                <CustomDropdown
                  options={secondFilterOptions}
                  value={secondFilter}
                  onChange={handleSecondFilterChange}
                  name="secondFilter"
                  placeholder="--Select--"
                  idKey="value"
                  displayKey="label"
                />
              </div>
              <input
                type="text"
                className="search-input"
                value={secondFilterSearch}
                onChange={(e) => setSecondFilterSearch(e.target.value)}
                placeholder="Search"
              />
            </div>
          </div>
        </div>
        <div className="ptable-wrapper">
          <table className="ptableClass">
            <thead>
              <tr>
                <th>Sr. No.</th>
                <th className="nav-tabs">Shipment Type</th>
                <th className="nav-tabs">Shipment Code</th>
                <th className="nav-tabs">Logistic Party</th>
                <th className="nav-tabs">Vehicle Number</th>
                <th className="nav-tabs">Route Name</th>
                <th className="nav-tabs">Action</th>
              </tr>
            </thead>
            <tbody>
              {currentPosts.length > 0 ? (
                currentPosts.map((shipment, index) => (
                  <tr key={index}>
                    <td>{indexOfFirstPost + index + 1}</td>
                    <td>
                      {shipment.SHPH_ShipmentType || shipment.SHPR_ShipmentType}
                    </td>
                    <td>
                      {shipment.SHPH_ShipmentCode || shipment.SHPR_ShipmentReturnCode}
                    </td>
                    <td>
                      {shipment.LGCM_Name}
                    </td>
                    <td>
                      {shipment.LGCVM_VehicleNumber}
                    </td>
                    <td>
                      {shipment.RUTL_Name}
                    </td>

                    <td>
                      <img src={Icon3} alt="pencil" className="editicon" width={25} onClick={() => handleRowClick(shipment)}/>
                      {(shipment.SHPH_Status === 2 &&
                        !SuspendShipments.includes(shipment.SHPH_ShipmentID)) ? (
                        <img
                          src={Icon4}
                          alt="suspendremovebg"
                          title="Suspend"
                          style={{ cursor: "pointer" }}
                          onClick={() => handleSuspendClick(shipment)}
                        />
                      ) : shipment.SHPR_Status === 2 &&
                        !SuspendShipments.includes(shipment.SHPR_ShipmentID) ? (
                        <img
                          src={Icon4}
                          alt="suspendremovebg"
                          title="Suspend"
                          style={{ cursor: "pointer" }}
                          onClick={() => handleSuspendClick(shipment)}
                        />
                      ) : (
                        "Suspended"
                      )}
                    </td>

                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="9" style={{ textAlign: "center" }}>
                    No Records Found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        {filteredCombinedData.length > itemsPerPage && (
          <ul className="pagination">
            <li className={currentPage === 1 || filteredCombinedData.length === 0 ? "page-item disabled" : "page-item"}>
              <button
                className="page-linkd"
                onClick={() => paginate(1)}
                disabled={currentPage === 1 || filteredCombinedData.length === 0}
              >
                First
              </button>
            </li>

            <li className={currentPage === 1 || filteredCombinedData.length === 0 ? "page-item disabled" : "page-item"}>
              <button
                className="page-linkd"
                onClick={() => paginate(currentPage - 1)}
                disabled={currentPage === 1 || filteredCombinedData.length === 0}
              >
                Previous
              </button>
            </li>

            {filteredCombinedData.length > 0 &&
              (() => {
                const totalPages = Math.ceil(filteredCombinedData.length / itemsPerPage);
                const maxVisiblePages = 10;
                const startPage = Math.max(1, Math.min(currentPage - Math.floor(maxVisiblePages / 2), totalPages - maxVisiblePages + 1));
                const pagesToShow = Math.min(maxVisiblePages, totalPages);

                return Array.from({ length: pagesToShow }, (_, index) => {
                  const page = startPage + index;
                  if (page > totalPages) return null;

                  return (
                    <li key={page} className={currentPage === page ? "page-item active" : "page-item"}>
                      <button className="page-linkd" onClick={() => paginate(page)}>{page}</button>
                    </li>
                  );
                });
              })()
            }

            {/* Next Page Button */}
            <li
              className={
                currentPage === Math.ceil(filteredCombinedData.length / itemsPerPage) || filteredCombinedData.length === 0
                  ? "page-item disabled"
                  : "page-item"
              }
            >
              <button
                className="page-linkd"
                onClick={() => paginate(currentPage + 1)}
                disabled={currentPage === Math.ceil(filteredCombinedData.length / itemsPerPage) || filteredCombinedData.length === 0}
              >
                Next
              </button>
            </li>

            {/* Last Page Button */}
            <li
              className={
                currentPage === Math.ceil(filteredCombinedData.length / itemsPerPage) || filteredCombinedData.length === 0
                  ? "page-item disabled"
                  : "page-item"
              }
            >
              <button
                className="page-linkd"
                onClick={() => paginate(Math.ceil(filteredCombinedData.length / itemsPerPage))}
                disabled={currentPage === Math.ceil(filteredCombinedData.length / itemsPerPage) || filteredCombinedData.length === 0}
              >
                Last
              </button>
            </li>
          </ul>
        )}
      </div>

      {isPopupVisible && (
        <div className="popup-box">
          <div className="popup-content-Suspend">
            <h5 className="Suspend-Popup-Heading">:: User Confirmation ::</h5>
            <p className="Suspend-Popup-Text">{Message}</p>
            <div className='remark_container'>
              <span className='me-3 remark_label'>
                Remark: {error && <span style={{ color: 'red' }}>{error}</span>}
              </span>
              <textarea
                type='text'
                className='remark_text'
                value={remark}
                onChange={handleRemarkChange}
                placeholder="Enter suspend remark"
                style={{
                  border: '1px solid #ced4da',
                  padding: '10px',
                  fontSize: '16px',
                  resize: 'none',
                  overflow: 'auto',
                  transition: 'height 0.3s',
                  borderRadius: "5px",
                  outline: "none"
                }}
              />
            </div>
            <div>
              <button className="button-Confirm-Popup" onClick={confirmSuspend}>
                YES
              </button>
              <button className="button-Close-Popup" onClick={closePopup}>
                NO
              </button>
            </div>
          </div>
        </div>
      )}
      <div className="button-container">
        <Link
          to={`/dashboard/ShipmentSelectScanType`}
          className="back_btn"
          type="button"
        >
          BACK
        </Link>
        <Link to={`/ShipOutScanedList`} className="list_btn" type="button">
          COMPLETED LIST
        </Link>
      </div>
    </>
  );
}

export default ShipOutScanPendingList;
